import { type JingleCollectionModel } from '@/shared/api'
import { showDeleteConfirmationModal } from '@/shared/lib/antd-utils'
import { COMMON_COLUMN_WIDTH } from '@/shared/lib/styling'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Space, type TableProps } from 'antd'
import { useUnit } from 'effector-react'

import { COLUMN_WIDTH } from '../../lib/column-width'
import { type JingleCollectionsSortState } from '../../lib/jingle-collections-query-model'
import { jingleCollectionDeleted } from '../../model/jingle-collection.model'

interface useJingleCollectionsTableColumnsProps {
  onEdit: (jingleCollectionId: string) => void
  sort: JingleCollectionsSortState
}
export const useJingleCollectionsTableColumns = ({
  onEdit: handleEdit,
  sort,
}: useJingleCollectionsTableColumnsProps): TableProps<JingleCollectionModel>['columns'] => {
  const deleteJingleCollection = useUnit(jingleCollectionDeleted)
  const handleDelete = (id: string) => {
    showDeleteConfirmationModal({
      onConfirm: () => {
        deleteJingleCollection({ id })
      },
    })
  }

  return [
    {
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      ellipsis: true,
      sortOrder:
        sort.field === 'name'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (name, _) => name,
    },
    {
      title: 'Дата',
      width: COLUMN_WIDTH.DATE,
      dataIndex: 'date',
      key: 'date',
      sorter: true,
      sortOrder:
        sort.field === 'date'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (_, jingleCollection) =>
        jingleCollection.startDate +
        (jingleCollection.endDate ? ' - ' + jingleCollection.endDate : ''),
    },
    {
      title: '',
      width: COMMON_COLUMN_WIDTH.ACTIONS,
      key: 'actions',
      align: 'center',
      render: (_, jingleCollection) => (
        <Space size="middle">
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(jingleCollection.id)}
          />
          <Button
            onClick={() => handleDelete(jingleCollection.id)}
            icon={<DeleteOutlined style={{ color: 'red' }} />}
          />
        </Space>
      ),
    },
  ]
}
